// Libraries
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// Import router from next
import { useNavigate } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import MenuList from '@mui/material/MenuList';
import Divider from '@mui/material/Divider';
import { Buffer } from "buffer";
import moment from "moment";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import mixpanel from 'mixpanel-browser';
import Button from '../button/button';

// Import supabase configuration
import supabase from "../../config/supabase";
import {
    getClientNotification,
  } from "../../redux/actions/actions";
  
// Client header
function Header({boardName = "" ,current = "", showLoader, loading, isPublic = false, justView = false,children,getClient, requestForm = false, handleOpenModal,showLogin=true, onLogOut,clientInvitationId="",isLogin, isSignUp,modal,toHomeUrl}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { clientNotification ,detailed_client_Profiles} = useSelector((state) => state.client);

    const [showTransition, setShowTransition] = useState(false);
    const [showMeetings, setShowMeetings] = useState(false);
    const [marked, setMarked] = useState(false);
    const [meetings, setMeeting] = useState([]);
    const [noShow, setNoShow] = useState(true);
    const [count, setCount] = useState(0);

    useEffect(()=> {
        mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 
    },[])

    useEffect( () => {
        
        if(clientNotification.length> 0) {
          var meetings = clientNotification;
          meetings.map((m,index)=> {
            //   Set dp url
            m.dpLink = detailed_client_Profiles.filter(p => p.id == m.profileId)[0]?.emoji_url || "/av.jpg";
            let date  = m.created_at && new Date(m.created_at);
            let newDate = date && new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
            var end = newDate ? moment(newDate).format('h:mm A') : "";
            m.time = end;
            
            var today = new Date();
            var yesterday = new Date(today);
      
            yesterday.setDate(yesterday.getDate() - 1);
      
            var checkDay = new Date(today);
      
            checkDay.setDate(checkDay.getDate() - 6);
      
            if((date.getMonth() == today.getMonth()) && (date.getDate() == today.getDate())){
              m.day = "Today"
            }
            else if((date.getMonth() == yesterday.getMonth()) && (date.getDate() == yesterday.getDate())){
              m.day = "Yesterday"
            }
            else if((date.getMonth() >= checkDay.getMonth()) && (date.getDate() == checkDay.getDate())){
              var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              var d =days[date.getDay()];
      
              m.day = d ;
            }
            else{
              m.day = moment(date).format('MMM Do');
            }
          })
          
          setMeeting(meetings);
    
        }
        
      },[clientNotification])

    const toHome = async() => {
        if(getClient){
            var url = new URL(window.location.href);
        
            let clientInvitationId = url.searchParams.get("client");
        
            if(clientInvitationId){
                localStorage.removeItem("loggedIn");
                let client = await getClient("url");
                url = client?.url.split("client")[1];
                localStorage.setItem("firstProfile",true);
                navigate(`/client${url}`);
            }
            else{
                mixpanel.track('toOtherCandidates');
                url = window.location.href.split("board")[1];
                localStorage.setItem("firstProfile",true);
                navigate(`/client?id${url}`);
            }
        }

        else if(requestForm){
            let url = localStorage.getItem("clientUrl");
            url = url.split("client")[1];
            navigate(`/client${url}`);
        }
        else if (toHomeUrl){
            navigate(`/client?id${toHomeUrl}`)
        }
    };

    const handleMenu = async (event) => {
        // var url = new URL(window.location.href);          
        // var token = url.searchParams.get("id").split("/")[1];

        // var url = localStorage.getItem("clientUrl") || "";
        // let redirectUrl = url && url.split("client")[1];

        // var dashboard_url = localStorage.getItem("dashboard") || "";

        setShowTransition(false);
        setNoShow(true);
        setCount(0);
        var user = JSON.parse(localStorage.getItem("supabase.auth.token")) || "";
        var email = user ? user?.currentSession.user.email : "";

        // Log out
        if (event.target.outerText === "Log Out") {
            const { error } = await supabase.auth.signOut();
            if (!error) {
                mixpanel.track('logout',{
                    'clientEmail' : email,
                });
                onLogOut && onLogOut();
                localStorage.clear();
                sessionStorage.clear("publicInfo");
                // token ? navigate(`/client${redirectUrl}`) : navigate(`/clientBoard?${dashboard_url}`)
                navigate('/clientLogin');
            }
        }
        // Forgot password
        if (event.target.outerText === "Forgot Password") {
            // write logic
        }
    };

    const BootstrapInput = styled(InputBase)(({ theme }) => ({
        "& .MuiInputBase-input": {
        "&:focus": {
            borderRadius: 4,
            borderColor: "",
            boxShadow: "",
        },
        root: {
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
    }));

    const controlMenuTransition = () => {
        setShowTransition(!showTransition);
        if(count == 0){
            setCount(1);
            setNoShow(!noShow);
        }
        else{
            count >=1 && setTimeout(() => {
                 showTransition && setNoShow(true);
                 setCount(0);
            }, 500);
        } 
       
    }

    const handleMeetings = () => {
        mixpanel.track('checked notification');
        localStorage.removeItem("showNumber");
        localStorage.setItem("notifications", JSON.stringify(meetings));
        let size = window.screen.availWidth;
        if(size > 768){
            setShowMeetings(!showMeetings);
        }
        else{
            navigate(`/notifications`); 
        } 
    }

    const markAsRead = async(check, profileId,meetings) => {
        var url = new URL(window.location.href);
        // On interview schedule page
		var client = url.searchParams.get("client");
		var client_invitation_id = Buffer.from(client || "", "base64").toString("utf-8");        
        localStorage.setItem('clientBoardProfile', profileId);

        if(client_invitation_id){
            if(check == "single"){
                loading(true);
                setShowMeetings(!showMeetings);
                var { data, error } = await supabase
                .from("notifications")
                .update({state : "read"})
                .match({client: client_invitation_id, profileId:profileId})
                
                if(data && data.length){
                    dispatch(getClientNotification(client_invitation_id))
                    
                    setMarked(true);
                    loading(false);
                    navigate(`/meetingDetails?id=${Buffer.from(client_invitation_id, "utf-8").toString("base64")}`);
                }
            }
            else{
                let meet = [...meetings];
                meet = meet.map(m => ({...m, state : "read"}))
                setMeeting(meet);

                var { data, error } = await supabase
                .from("notifications")
                .update({state : "read"})
                .match({client: client_invitation_id})
    
                if(data && data.length){
                    dispatch(getClientNotification(client_invitation_id));
                }
            } 
        }
        else{
            if(check == "single"){
                loading(true);
                setShowMeetings(!showMeetings);
                var { data, error } = await supabase
                .from("notifications")
                .update({state : "read"})
                .match({client: clientInvitationId, profileId:profileId})

                if(data && data.length){
                    dispatch(getClientNotification(clientInvitationId))
                    setMarked(true);
                    loading(false);
                    navigate(`/meetingDetails?id=${Buffer.from(clientInvitationId, "utf-8").toString("base64")}`);
                }
            }
            else{
                let meet = [...meetings];
                meet = meet.map(m => ({...m, state : "read"}))
                setMeeting(meet);

                var { data, error } = await supabase
                .from("notifications")
                .update({state : "read"})
                .match({client: clientInvitationId})

                if(data && data.length){
                    dispatch(getClientNotification(clientInvitationId));
                }
            }
        }
    }

    const handleLoginClick = () => {
        handleOpenModal();
        if(modal){
            isSignUp();
        }
    }

    
  const handleMenuClickAway = (event) => {

    if (event.target.outerText === "Log Out" || event.target.outerText === "Forgot Password") {
        handleMenu(event);
    }
    else{
        if(showTransition){
            setShowTransition(!showTransition);

            setTimeout(() => {
                setNoShow(true);
                setCount(0);

           }, 500);
        }
    } 
  };

  const handleNotificationsClickAway = (event) => {
    setShowMeetings(false);
  };

    // return
    return (
        // Render header
            <div className="h-full">

                <div className="flex sticky top-0 z-50">
                    <div className="flex justify-between shadow-clientHeader items-center relative w-full h-16 md:h-20 bg-white-1 px-5 box-border">
                        {/* For small screens */}
                        <div className="md:hidden">
                            {/* Add icon */}
                            <p onClick={() => toHome()}>
                                <img src="/Logo.svg" className="pl-2 cursor-pointer" />
                            </p>
                        </div>
                        {/* Make a group */}
                        {/* For large screens */}
                        <div className="relative hidden md:flex">
                            {/* Add icon */}
                            <p onClick={() => toHome()}>
                                <img src="/Gaperio2.svg" className="cursor-pointer" />
                            </p>
                            <span className="invisible md:visible flex items-center ml-5">{current == "client" ? "Boards" : boardName}</span>
                        </div>
                    
                        {(!justView  && showLogin)  ? (
                            <div className="justify-end cursor-pointer" onClick={handleLoginClick}>
                            
                            {!showLoader && (isLogin ? 'Signup' : 'Login')}
                            </div>

                        ) : ((!justView || isPublic ) || current == "client") && <div className="flex justify-end relative">

                            {/* Add request button */}
                            <Button  className="mr-6 mt-1.5 hidden md:flex" value="Request a new list" buttonType="request" onClick={() => {navigate(`/form`);  mixpanel.track('Request for new list')}}/>

                            <ClickAwayListener onClickAway={(e) => handleNotificationsClickAway(e)}>
                                <div>

                                   {/* show Meetings */}
                                    <div className={`${showMeetings ? "" : "hidden"} absolute text-sm shadow-clientHeaderMenu right-14 top-12 w-notification bg-white-1 ${meetings.length > 3 ? "h-notification overflow-auto" : ""} `}>
                                        <div className="flex justify-between p-5">
                                            <div className="font-medium">Meetings</div>
                                            {
                                                (meetings.length > 0 && meetings.some(m => m.state == "new") ) && <div className="flex cursor-pointer" onClick={() => markAsRead("all", "",meetings)}>Mark all as read <svg className="ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z"/></svg></div>
                                            }   
                                            </div>
                                        <div>
                                            {meetings.length > 0 ? <div className="mt-1">
                                                {
                                                    meetings.map((n,index) => ( <div className="grid grid-cols-12 gap-x-3 hover:bg-green-2 cursor-pointer" key={index} onClick={() => markAsRead("single",n.profileId,meetings)}>
                                                        {/* Show dot */}
                                                        {
                                                            n.state == "new" && <div className="col-span-12 w-3 h-3 bg-blue-4 rounded-full ml-2 mt-3"></div>
                                                        }
                                                        
                                                        {/* Show image */}
                                                        <div className={`bg-blue-9 w-10 h-10 col-span-2 rounded-full p-1 ml-5 ${n.state == "new" ? "-mt-2" : "mt-3"} `}>
                                                            <img src={n.dpLink} className="w-7 h-9 ml-0.5 mb-0.5" />
                                                        </div>
                                                        <div className={`col-span-10 pr-5 mb-2 ${n.state == "new" ? "-mt-2" : "mt-3"}`}> {n?.message.split("with")[0]} with <span className="font-medium">{n?.message.split("with")[1]}</span></div>
                                                        {/* Add space */}
                                                        <div className="col-span-2"></div>
                                                        <div className="col-span-10 text-sm font-semibold text-grey-5 mb-3">{n.day} at {n.time}</div>
                                                    { index != meetings.length -1 && <div className="col-span-12"> <Divider /></div>}
                                                    
                                                    </div>
                                                    ))
                                                } 
                                                </div>: <div className="px-5 my-2">You will receive notifications here</div>
                                            }
                                        </div>
                                    </div >

                                    {/* Meeting icon */}
                                    <div className={`${current == "client" ? "hidden" : ""}`}>
                                        {
                                            (localStorage.getItem("showNumber") == "true") ? <img src="/notification2.svg" className="mr-6 w-10 h-10 mt-1.5" onClick={() => handleMeetings()}/>
                                        :  <img src="/notification.svg" className="md:mr-6 mr-3 w-8 h-8 md:w-9 md:h-10 mt-2 md:mt-1.5 cursor-pointer" onClick={() => handleMeetings()}/>
                                        }
                                    </div>
                                </div>
                            </ClickAwayListener>

                            {/* Show menu */}
                            <div className={`${ showTransition ? "showHeaderTransition" : (noShow && !showTransition) ? "hidden" : "hideHeaderTransition"} bg-white-1 mt-14 text-sm shadow-clientHeaderMenu z-10`} >

                                <MenuList className="rounded"  input={<BootstrapInput />} >
                                
                                    <MenuItem value="  Log Out  " onClick={(e) => {handleMenu(e)}}>
                                        Log Out
                                    </MenuItem>
                                </MenuList>
                            
                            </div>

                            <ClickAwayListener onClickAway={(e) => handleMenuClickAway(e)}>
                                <div>
                                    {/* For small screens */}
                                    <div className="relative md:hidden mt-1">
                                        <Avatar alt="Profile" src="/fm_mb.svg" className="cursor-pointer" onClick={() => controlMenuTransition()}/>
                                    </div> 
                                        
                                    {/* For large screens */}
                                    <div className="hidden md:flex relative mt-1.5">
                                        <Avatar alt="Profile" src="/av2.png" className="cursor-pointer" onClick={() => controlMenuTransition()}/>
                                    </div> 
                                </div>  
                            </ ClickAwayListener >
  
                        </div> }
                    </div>
                </div>

                <div>
                    {children}
                </div>
            </div>
    );
}

// Export the Component
export default Header;
